<template>
  <DBox
    :id="'cmp-settings-booking-field-table'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="linkLabelName"
    @add_click="onAddNewFieldClick"
    :rightMenu="[
      {
        text: $t('save_btn'),
        value: 'save',
      },
    ]"
    @menuClick="onRightMenuClick"
  >
    <!-- v-if="custom_fields.length > 0" -->
    <NTable
      class="fields-list dbox1"
      :headers="headers"
      :items="custom_fields"
      :config="tableConfig"
      :showNoItems="true"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td :class="{ field_label: true, custom: !item.key }">
            <div class="field_label_value" v-if="item.key">
              {{ $t(item.field_label) }}
            </div>
            <input
              v-if="!item.key"
              type="text"
              class="ntable--textfield"
              name="field_label"
              :id="`field_label-${item.field_label}`"
              :placeholder="$t('field_label')"
              :value="item['field_label']"
              v-on:blur="(e) => onTextInputBlur(e, 'field_label', item)"
            />
          </td>
          <td class="main_contact_for_artist_flag">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="main_contact_id"
                  id="main_contact_id"
                  :checked="getRequest(item)"
                  @click="(e) => onCheckboxChange(e, 'request', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td class="description">
            <div class="checkbox-container"  v-if="!item.disable_questionnaire">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="contract_flag"
                  id="contract_flag"
                  :checked="getQuestion(item)"
                  @click="(e) => onCheckboxChange(e, 'question', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td class="mandatory">
            <div class="checkbox-container" v-if="!item.disable_mandatory">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="mandatory"
                  id="mandatory"
                  :checked="getMandatory(item)"
                  @click="(e) => onCheckboxChange(e, 'mandatory', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td class="option">
            <div class="dt-icon-container" v-if="!item.key">
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="(e) => onDeleteCustomField(item)"
                :alt="$t('delete_custom_field')"
                :title="$t('delete_custom_field')"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

export default {
  components: {
    NTable,
    DBox,
  },
  props: {
    linkLabelName: {
      type: String,
    },
    custom_fields: {
      type: Array,
      default: () => [],
    },
    conf: {
      type: Object,
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        // rowHeight: 32,
        fullHeight: true,
        // footer: false
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        { text: this.$t(""), value: "field_label" },
        { text: 'request_l', value: "request" },
        { text: 'questionnaire_l', value: "questionnaire" },
        { text: 'mandatory_l', value: "mandatory" },
        { text: this.$t(""), value: "option" },
      ];
    },
  },
  methods: {
    onAddNewFieldClick: function () {
      this.$emit("add_click", true);
    },
    onCheckboxChange: function (event, name, item) {
      const key = item.key ? item.key : item.field_label;
      this.$emit("changed", {
        value: event.target.checked,
        name,
        key,
      });
    },
    onTextInputBlur: function (event, name, item) {
      this.$emit("field_changed", {
        kVal: item.custom_field_id,
        name: "field_label",
        value: event.target.value,
      });
    },
    onDeleteCustomField: async function (custom_field) {
      const confirmationResult = await confirmDelete(
        "Field",
        `Label: ${custom_field.field_label}`
      );
      if (confirmationResult == "OK") {
        this.$emit("delete", custom_field);
      }
    },
    getConf: function (name, key) {
      // console.log(name, key);
      return this.conf && this.conf[key] && this.conf[key][name] == 1
        ? true
        : false;
    },
    getMandatory: function (item) {
      const key = item.key ? item.key : item.field_label;
      return this.getConf("mandatory", key);
    },
    getQuestion: function (item) {
      const key = item.key ? item.key : item.field_label;
      return this.getConf("question", key);
    },
    getRequest: function (item) {
      const key = item.key ? item.key : item.field_label;
      return this.getConf("request", key);
    },
    onRightMenuClick: function () {
      this.$emit("saveSettings");
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-booking-field-table {
  .dt-ntable {
    // --ntable-td-padding: 0px 10px !important;
    th {
      span {
        text-align: center !important;
      }
    }

    th:nth-child(1),
    td:nth-child(1) {
      flex: 1.2;
      // color: var(--text-secondary);
      &.custom {
        color: var(--text-primary);
      }
    }
    th:nth-child(2),
    td:nth-child(2),
    th:nth-child(3),
    td:nth-child(3),
    th:nth-child(4),
    td:nth-child(4) {
      flex: 0.5;
      min-width: 95px;
      text-align: center;
    }
    th:nth-child(5),
    td:nth-child(5) {
      max-width: 30px;
    }

    .ntable--textfield {
      min-width: 0;
      background-color: var(--fc2-bc);
      color: var(--text-primary);
      border: 1px solid transparent;
      outline: none;
      padding: 0px 10px;
      margin: 3px 3px 3px 0;
      resize: none;
      border-radius: 4px;
      box-sizing: border-box;
      transition: margin 50ms ease-in-out, padding 50ms ease-in-out,
        border-radius 50ms ease-in-out;

      &:hover {
        outline: none;
        border: 1px solid var(--bc-cblue5);
      }

      &:focus,
      &:active {
        border-color: var(--fc2-bc);
        border-right-color: var(--cornblue);
        border-left-color: var(--cornblue);
        outline: none;
        background: var(--fc2-bc);
        margin: -1px 0;
        border-radius: 0;
        transition: margin 50ms ease-in-out, padding 50ms ease-in-out,
          border-radius 50ms ease-in-out;
      }
    }
  }
}
</style>
